import axios from 'axios';

export function getAICarousel() {
  return axios.get('/api/internal/ai/native/carousel');
}

export function getAIStory() {
  return axios.get('/api/internal/ai/native/story');
}

export function getSceneInfo(params: any) {
  return axios.get(`/api/internal/ai/native/scene?${new URLSearchParams(params).toString()}`);
}

export function getSceneFilter() {
  return axios.get('/api/internal/ai/native/scene/select/options/list');
}